module.exports = __webpack_public_path__ + "img/map_suite-locations_classic-rentals.6d92a562.jpg";